import { createStyles, makeStyles, fade, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = (pageYOffset, isHeaderHidden) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      header: {
        ...(isHeaderHidden && { display: 'none' }),
        transition: 'background .5s ease-in-out',
        background: pageYOffset > 0 ? colorsPalette.blueDark : 'transparent',
        boxShadow: pageYOffset > 0 ? `0px 3px 6px ${fade(colorsPalette.black, 0.4)}` : 'none',

        [theme.breakpoints.up('md')]: {
          background: pageYOffset > 0 ? fade(colorsPalette.blueDark, 0.85) : 'transparent',
          boxShadow: 'none',
        },

        '&$openSearch': {
          '&:after': {
            content: '""',
            display: 'block',
            position: 'fixed',
            width: '100%',
            height: '100%',
            background: 'rgba(27, 25, 37, 0.82)',
            top: 0,
            zIndex: -1,
          },
        },
      },
      toolBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 16,
        fontSize: '18px',
        transition: 'all .5s ease-in-out',
        [theme.breakpoints.up('sm')]: {
          padding: pageYOffset > 0 ? '10px 16px' : '30px 16px',
          fontSize: '16px',
        },
        [theme.breakpoints.up('md')]: {
          padding: pageYOffset > 0 ? '10px 24px' : '30px 24px',
        },
        [theme.breakpoints.up('xl')]: {
          padding: pageYOffset > 0 ? '10px 30px' : '30px',
        },
      },
      topBar: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'flex-start',
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: '0%',
        alignItems: 'center',
        zIndex: 1,

        [theme.breakpoints.up('md')]: {
          height: 54,
        },

        '&$openSearch': {
          flexGrow: 1,
          paddingLeft: 40,
          [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-end',
            marginRight: 24,
          },
          [theme.breakpoints.up('md')]: {
            marginRight: 0,
            justifyContent: 'flex-start',
          },
        },
        '& > $username': {
          display: 'none',
          [theme.breakpoints.up('md')]: {
            display: 'block',
          },
        },
      },
      topNavMenu: {
        display: 'none',
        [theme.breakpoints.up('xl')]: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          marginLeft: MIDDLE_MARGIN,
        },
      },
      topNavButton: {
        height: 24,
        padding: 0,
        marginRight: 24,
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
        '&$openSearch': {
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
        },
      },
      topNavIcon: {
        width: 20,
        height: 20,
        [theme.breakpoints.up('xl')]: {
          display: 'none',
        },
      },
      logoWrapper: {
        display: 'flex',
        height: 45,
        alignItems: 'center',
        transition: 'all .5s ease-in-out',
        zIndex: 1,
        '& img': {
          height: 32,
        },
        '@media only screen and (min-width: 375px)': {
          '& img': {
            height: 40,
          },
        },
        '@media only screen and (min-width: 425px)': {
          '& img': {
            height: 45,
          },
        },
        [theme.breakpoints.up('md')]: {
          height: 60,
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: '0%',
          '& img': {
            height: pageYOffset > 0 ? 45 : 60,
            transition: 'all .5s ease-in-out',
          },
        },
        '&$openSearch': {
          display: 'none',

          [theme.breakpoints.up('sm')]: {
            display: 'block',
            flexGrow: 0,
          },
        },
      },
      joinBtnLink: {
        color: colorsPalette.white,
        marginRight: SMALL_MARGIN / 2,
        [theme.breakpoints.up('sm')]: {
          '&:last-child': {
            marginRight: SMALL_MARGIN,
          },
        },
        [theme.breakpoints.up('xl')]: {
          '&:last-child': {
            marginRight: 0,
          },
        },
      },
      joinBtn: {
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('sm')]: {
          marginBottom: 0,
        },
      },
      accBtn: {
        width: 48,
        height: 48,
        cursor: 'pointer',
        marginLeft: SMALL_MARGIN,
        marginRight: SMALL_MARGIN,
        background: colorsPalette.whiteSecondary,
        padding: 12.5,
        transition: '0.5s',
        borderRadius: '999em',
        '&:hover': {
          boxShadow: `0px 3px 6px ${colorsPalette.black}`,
          background: theme.palette.primary.main,
          '& svg': {
            filter:
              'brightness(0) saturate(100%) invert(7%) sepia(28%) saturate(734%) hue-rotate(210deg) brightness(99%) contrast(93%)',
          },
        },

        '&$openSearch': {
          display: 'none',

          [theme.breakpoints.up('md')]: {
            display: 'block',
          },
        },
      },
      overlayContent: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      },
      searchWrapper: {
        marginRight: 12,

        [theme.breakpoints.up('md')]: {
          marginLeft: MIDDLE_MARGIN,
        },

        [theme.breakpoints.up('lg')]: {
          marginRight: 24,
        },
      },
      openSearch: {},
      linkWrapper: {
        zIndex: 1,
        position: 'relative',
        marginBottom: 24,
      },
      link: {
        color: colorsPalette.white,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontSize: 16,
        lineHeight: 1.2,
      },
      logout: {
        marginTop: SMALL_MARGIN,
        padding: '9px 0',
        background: colorsPalette.violetAnalyticsCard,
        borderRadius: '0 0 10px 10px',
        display: 'flex',
      },
      userInfoWrapper: {
        paddingBottom: 24,
        borderBottom: `1px solid ${fade(colorsPalette.white, 0.15)}`,
        marginBottom: 24,
      },
      username: {
        color: colorsPalette.white,
        fontSize: 18,
        lineHeight: 1.2,
        fontWeight: 'bold',
        marginBottom: 2,
        zIndex: 2,
      },
      team: {
        fontSize: 14,
        color: colorsPalette.gray,
        lineHeight: 1.5,
      },
      linksWrapper: {
        display: 'flex',
        flexDirection: 'column',
      },
      accordionLinks: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& $linkWrapper:last-child': {
          marginBottom: 0,
        },
      },
      overlayMainContent: {
        marginBottom: MIDDLE_MARGIN,
      },
      overlayBottomLink: {
        padding: '24px',
        color: colorsPalette.white,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontSize: 16,
        background: colorsPalette.violetAnalyticsCard,
        display: 'block',
        width: '100vw',
        marginLeft: -24,
        marginBottom: -24,
        border: 'none',
        '&:focus': {
          outline: 'none',
        },
        [theme.breakpoints.up('sm')]: {
          marginLeft: -30,
          marginBottom: -30,
          padding: '24px 30px',
        },
      },
      overlayContainer: {
        marginBottom: SMALL_MARGIN,
      },
      menuItemsWithMargin: {
        marginBottom: SMALL_MARGIN,
      },
    });
  });

export default useStyles;
